import { Page } from "@/shared/components/layers/Page/Page"
import { useNavigate } from "react-router-dom"
import { useCallback, useState } from "react"
import css from './Auth.module.css'
import { useAuth } from "../../lib/useAuth"
import { useAuthActions } from "../../lib/useAuthActions"

function Auth() {
  const { login } = useAuthActions()
  const { loading, error } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const isLoading = loading.login

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault()
    if (isLoading || !email.trim() || !password.trim()) return
    const result = await login(email.trim(), password)
    if (result) {
      navigate('/SalePlan', { replace: true })
    }
  }, [email, password, isLoading, login, navigate])

  return (
    <Page title="OKG: Вход">
      <div className={css.page}>
        <form className={css.form} onSubmit={handleSubmit}>
          <h1 className={css.title}>Вход в систему</h1>
          <div className={css.field}>
            <label className={css.label} htmlFor="auth-email">Email</label>
            <input
              id="auth-email"
              type="email"
              className={css.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="user@okgnn.ru"
              autoComplete="email"
              disabled={isLoading}
              autoFocus
            />
          </div>
          <div className={css.field}>
            <label className={css.label} htmlFor="auth-password">Пароль</label>
            <input
              id="auth-password"
              type="password"
              className={css.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              disabled={isLoading}
            />
          </div>
          {error.login && (
            <p className={css.error} role="alert">
              {typeof error.login === 'string' ? error.login : 'Ошибка входа. Проверьте данные.'}
            </p>
          )}
          <button
            type="submit"
            className={css.submit}
            disabled={isLoading || !email.trim() || !password.trim()}
          >
            {isLoading ? 'Вход…' : 'Войти'}
          </button>
        </form>
      </div>
    </Page>
  )
}

export default Auth